<script>

export default {
    data() {
      return {
        mounted: false,
        selected: {
          segment_id: null,
          technology_id: null
        }
      };
    },
    mounted() {
      this.mounted = true
    },
    methods: {
      updateSelect(name, value) {
        this.selected[name] = value;
      }
    }
  };

</script>